import React from "react";
const OpacityContext = React.createContext();
export default OpacityContext;
